import React, { useState, useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { withCookies } from 'react-cookie';
import '../../../css/huerto/modalsFichaCliente.css';
import Datepicker from '../../../bronson/Datepicker';
import ContractsService from '../../../../services/ContractsService';
import Globals from '../../../../Globals';
import FunctionGeneral from '../functionsGeneral';
import Input from '../../../bronson/Input';

function formatFechaExpiration(date) {
    let _date = date.split('T')[0].split('-');
    let fechaReturn = new Date();
    fechaReturn.setDate(_date[2] - 2);
    fechaReturn.setMonth(_date[1] - 1);
    fechaReturn.setFullYear(_date[0]);

    return (
        fechaReturn.getDate() +
        '/' +
        (fechaReturn.getMonth() + 1) +
        '/' +
        fechaReturn.getFullYear()
    );
}
function formatFecha(dataFecha) {
    try {
        dataFecha = dataFecha.split('T')[0];
        dataFecha = dataFecha.split('-');
        return dataFecha[2] + '/' + dataFecha[1] + '/' + dataFecha[0];
    } catch {
        return '';
    }
}
function SHOW(element) {
    let elementTarget = document.getElementById(element);
    if (elementTarget.style.display == 'none') {
        document.getElementById(element + '_active').classList.add('is-active');
        elementTarget.style.display = '';
    } else {
        document
            .getElementById(element + '_active')
            .classList.remove('is-active');
        elementTarget.style.display = 'none';
    }
}

function ModalCancelacionAnticipada(props) {
    const [scrollTable, setscrollTable] = useState(false);
    const [datePickerFromValue, setDatePickerFromValue] = useState(
        new FunctionGeneral().fechainicial()
    );
    const [dateCalculo, setDateCalculo] = useState([]);
    const [check_client, setCheck_client] = useState(false);
    const [check_EnviarCertificado, setcheck_EnviarCertificado] = useState(
        false
    );
    const [mail_client, setmail_client] = useState(false);
    const [correoLPASend, set_CorreoLPASend] = useState('');
    const [resultSendCerticate, setresultSendCerticate] = useState([]);
    const [SeleccionError, setSeleccionError] = useState('');

    useEffect(() => {
        if (props.cancelacionAnticipadaIDSelect !== '') {
            props.setLoading(true);
            newLPAID(props.cancelacionAnticipadaIDSelect);
            setscrollTable(!scrollTable);
        } else
            document.querySelector(
                '#fecha-SimulacionAnticipada'
            ).value = datePickerFromValue;
        window.bronson.ComponentRegister.initAll();
    }, []);

    useEffect(() => {
        window.bronson.ComponentRegister.initAll();
    }, [dateCalculo]);

    useEffect(() => {
        if (!mail_client) set_CorreoLPASend(props.mail);
        else set_CorreoLPASend('');
        if (document.getElementById('correo_SendLPA'))
            document.getElementById('correo_SendLPA').value = '';
    }, [mail_client]);

    useEffect(() => {
        set_CorreoLPASend(props.mail);
    }, [props.mail]);

    useEffect(() => {
        if (props.esCancelacionCliente) setCheck_client(true);
    }, [props.esCancelacionCliente]);

    function onchangeCorreo() {
        if (mail_client)
            set_CorreoLPASend(document.getElementById('correo_SendLPA').value);
    }

    async function newLPAID(datanewLPA) {
        props.setLoading(true);
        var _datanewLPAResult = await new ContractsService().simulacionLPAIDResult(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken,
            datanewLPA
        );
        if (
            _datanewLPAResult &&
            _datanewLPAResult.statusCode === 200 &&
            _datanewLPAResult.body &&
            _datanewLPAResult.body.Result
        ) {
            var datanewLPAResult = JSON.parse(_datanewLPAResult.body.Result);
            props.setLoading(false);
            setDateCalculo(datanewLPAResult);
        }
    }

    async function newLPA(valueDate) {
        if (check_client) props.changeAccionLogs('SOLICITUD_LPA_CLIENTE');
        else props.changeAccionLogs('SOLICITUD_LPA_DEALER');

        props.setLoading(true);
        var _datanewLPA = await new ContractsService().newSimulacionLPA(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken,
            props.cookies.get(Globals.COOKIES.USER),
            props.operacionCode,
            valueDate,
            check_client
        );
        if (
            _datanewLPA &&
            _datanewLPA.statusCode === 200 &&
            _datanewLPA.body &&
            _datanewLPA.body?.Errors?.length == 0 &&
            _datanewLPA.body.Result
        ) {
            setSeleccionError('');
            setcheck_EnviarCertificado(true);
            var datanewLPA = JSON.parse(_datanewLPA.body.Result);
            newLPAID(datanewLPA);
            props.setDataSimulacionProps();
        } else {
            var error = _datanewLPA.body?.Errors[0]?.Value;
            var showError = '';
            try {
                showError = error.split('{')[0];
            } catch {
                showError = error;
            }

            setSeleccionError(showError);
            //setSeleccionError(_datanewLPA.body?.Errors[0]?.Value);
            props.setLoading(false);
        }
    }

    function calcular() {
        if (!scrollTable) {
            newLPA(document.querySelector('#fecha-SimulacionAnticipada').value);
            setDatePickerFromValue(
                document.querySelector('#fecha-SimulacionAnticipada').value
            );
        }
        setscrollTable(!scrollTable);
    }

    async function enviarCertificado() {
        var fecha = datePickerFromValue.split('/');
        var fechasend = fecha[2] + '-' + fecha[1] + '-' + fecha[0];
        var nifTitular =
            props.TitularNIF?.Nif ?? props.rowselect?.TitularNIF ?? '';
        var _datanewLPA = await new ContractsService().getCertificateLPA(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken,
            props.cookies.get(Globals.COOKIES.USER),
            nifTitular,
            props.operacionCode,
            fechasend,
            correoLPASend
        );
        if (_datanewLPA && _datanewLPA.statusCode === 200 && _datanewLPA.body) {
            setresultSendCerticate(JSON.parse(_datanewLPA.body.Result));
            if (!mail_client) props.changeAccionLogs('CERTIFICATE_LPA_CLIENTE');
            else props.changeAccionLogs('CERTIFICATE_LPA_DEALER');
        }
    }

    const showSeleccionError = () => {
        if (SeleccionError && SeleccionError != '')
            return (
                <div className="u-1/1">
                    <div className="u-1/1">
                        <label className="u-text-base u-text-left u-1/1">
                            {SeleccionError}
                        </label>
                    </div>
                </div>
            );
        else return null;
    };

    const printResultView = () => {
        if (!check_EnviarCertificado || !dateCalculo.SolicitadaPorCliente)
            return null;
        if (check_EnviarCertificado && resultSendCerticate.length === 0) {
            return (
                <div>
                    <h4 className="u-text-left">
                        Enviar Certificado del resumen de cancelación
                    </h4>
                    <div
                        className="infoResumen u-p"
                        style={{ display: 'flex' }}
                    >
                        {props.mail !== '' && (
                            <div
                                onChange={() => {
                                    setmail_client(!mail_client);
                                }}
                                className="u-1/2 u-float-left u-text-left u-pr"
                            >
                                <label className="c-radio u-pb">
                                    <input
                                        className="c-radio__input"
                                        type="radio"
                                        name="radio-button"
                                        defaultChecked={true}
                                    />
                                    <span className="c-radio__label">
                                        Enviar al correo asociado al perfil de
                                        la cuenta{' '}
                                    </span>
                                </label>
                                <div className="u-text-left u-pl-small">
                                    {props.mail}
                                </div>
                            </div>
                        )}
                        <div className="u-1/2 u-float-left u-text-left">
                            <label
                                className="c-radio u-pb"
                                onChange={() => {
                                    setmail_client(!mail_client);
                                }}
                            >
                                <input
                                    className="c-radio__input"
                                    type="radio"
                                    name="radio-button"
                                />
                                <span className="c-radio__label">
                                    Enviar a otro correo
                                </span>
                            </label>

                            <div
                                className="input-div u-1/1"
                                onChange={() => onchangeCorreo()}
                            >
                                <Input
                                    options={{
                                        id: 'correo_SendLPA',
                                        type: 'text',
                                        placeHolder:
                                            'Introduce un correo electrónico',
                                        autoComplete: 'off',
                                        disabled:
                                            correoLPASend === props.mail
                                                ? true
                                                : false,
                                    }}
                                    onChange={() => {}}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else
            return (
                <div>
                    <section style={{ minHeight: '150px', display: 'grid' }}>
                        <div
                            className="u-1/1 infoResumen"
                            style={{ marginBottom: '20px' }}
                        >
                            <label className="o-layout__item u-1/3 labelConsT">
                                {' '}
                                Código de Operación
                            </label>
                            <label className="o-layout__item u-2/3 labelConsT u-text-right u-pr">
                                {props.operacionCode &&
                                props.operacionCode != ''
                                    ? props.operacionCode
                                    : props.rowselect.FinancialOperationCode}
                            </label>
                            <label className="o-layout__item u-1/3 labelConsT">
                                Email envío certificado
                            </label>
                            <label className="o-layout__item u-2/3 labelConsT u-text-right u-pr u-pb">
                                {resultSendCerticate.mail}
                            </label>

                            {!resultSendCerticate.error && (
                                <label className="o-layout__item u-1/1 labelConsT u-text-right u-pr">
                                    El certificado LPA se envio con éxito
                                </label>
                            )}
                            {resultSendCerticate.error && (
                                <div
                                    id="ErrorPLA_active"
                                    className="c-accordion__header  js-accordion__title o-layout__item u-1/1"
                                    onClick={() => SHOW('ErrorPLA')}
                                >
                                    <span className="c-accordion__title-icon"></span>
                                    <h4 className="c-accordion__title u-pl u-text-left">
                                        <button className="c-accordion__title-label  js-accordion__title-label">
                                            Ha ocurrido un error al enviar el
                                            certificado
                                        </button>
                                    </h4>
                                </div>
                            )}

                            <div
                                className="js-accordion__panel"
                                id="ErrorPLA"
                                style={{ display: 'none' }}
                            >
                                <div className="c-accordion__content c-accordion__content--max-width">
                                    {resultSendCerticate.message}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            );
    };
    var item = [];
    if (dateCalculo.DesgloseCancelacion !== undefined)
        dateCalculo.DesgloseCancelacion.forEach(element => {
            item.push(
                <div
                    key={item.length}
                    className="o-split"
                    style={{
                        backgroundColor:
                            item.length % 2 === 0 ? 'rgb(242, 242, 242)' : '',
                    }}
                >
                    <p style={{ lineHeight: '24px', margin: '0px' }}>
                        {element.Description}
                    </p>
                    <p
                        style={{
                            lineHeight: '24px',
                            margin: '0px',
                            marginLeft: '5px',
                        }}
                    >
                        {new FunctionGeneral().formatNum(element.Value)}€
                    </p>
                </div>
            );
        });

    const printCalculo = () => {
        if (props.cancelacionAnticipadaIDSelect === '' && !scrollTable)
            return (
                <div className="u-1/1">
                    <div className="u-mt">
                        <label className="u-text-base u-text-left u-1/1">
                            Fecha Cancelación
                        </label>
                        <div className="input-div u-float-left">
                            <Datepicker
                                options={{
                                    id: 'fecha-SimulacionAnticipada',
                                    type: 'date',
                                    minDate: new FunctionGeneral().fechainicial(),
                                    maxDate: formatFechaExpiration(
                                        props.fecha_expirate
                                    ),
                                }}
                                onChange={() => {}}
                            ></Datepicker>
                        </div>
                    </div>

                    {props.esCancelacionCliente ? (
                        <div className="u-1/1 u-text-left u-float-left u-mt u-mb"></div>
                    ) : (
                        <div className="u-1/1 u-text-left u-float-left u-mt u-mb">
                            <label
                                className="c-checkbox pickupCheckbox u-float-left"
                                id="check_client"
                            >
                                <input
                                    className="c-checkbox__input"
                                    id="sameOffice"
                                    type="checkbox"
                                    name="checkbox"
                                    onChange={() =>
                                        setCheck_client(!check_client)
                                    }
                                />
                                <span className="c-checkbox__label checkbox-span returnSameOffice-span">
                                    {' '}
                                </span>
                            </label>
                            <label className="u-float-left">
                                Esta simulacion ha sido solicitada por el
                                cliente
                            </label>
                        </div>
                    )}

                    <div className="u-1/1">
                        <button
                            className="c-btn u-float-left"
                            style={{
                                display: 'flow-root',
                                width: '35%',
                                height: '40px',
                            }}
                            onClick={() => {
                                calcular();
                            }}
                        >
                            Calcular
                        </button>
                    </div>
                </div>
            );
        else return null;
    };

    return (
        <div className="c-modal" aria-hidden={'false'}>
            <div className="c-modal__overlay js-modal-close"></div>
            <div
                className="c-modal__wrapper modalFichaCliente"
                role="dialog"
                aria-labelledby="foo-bar-baz"
            >
                <header className="c-modal__header">
                    <div className="o-layout__item u-11/12">
                        <label className="u-h3 u-ml-xsmall">
                            Simulación de Cancelación anticipada de un contrato
                        </label>
                    </div>

                    <div className="u-1/12">
                        <button
                            onClick={() =>
                                props.setModalCancelacionAnticipada(false)
                            }
                            className="c-modal__close-btn  js-modal-close"
                            type="button"
                            aria-label="Close this dialog window."
                        />
                    </div>
                </header>

                <div className="c-modal__content">
                    <section style={{ minHeight: '150px', display: 'grid' }}>
                        {dateCalculo.DesgloseCancelacion === undefined && (
                            <div style={{ marginBottom: '40px' }}>
                                <p className="u-text-left">
                                    A continuación puedes realizar simulaciones
                                    de cancelación de un contrato. El tipo de
                                    cancelación será Total Anticipada.
                                </p>
                            </div>
                        )}
                        {printCalculo()}
                        {showSeleccionError()}
                        {scrollTable &&
                            dateCalculo.DesgloseCancelacion !== undefined && (
                                <section
                                    className="u-1/1 u-pt"
                                    id="resumenValue"
                                >
                                    <h5 className="colorBlue u-text-left u-h6">
                                        Resumen
                                    </h5>
                                    <div className="u-1/1 infoResumen">
                                        <label className="o-layout__item u-2/3 labelConsT">
                                            Fecha Cálculo
                                        </label>
                                        <label className="o-layout__item u-1/3 labelConsT u-text-right u-pr">
                                            {formatFecha(
                                                dateCalculo.FechaPagoAmortizcionPrestamo
                                            )}
                                        </label>

                                        <label className="o-layout__item u-2/3 labelConsT">
                                            Primer vencimiento incluido en
                                            cancelación
                                        </label>
                                        <label className="o-layout__item u-1/3 labelConsT u-text-right u-pr">
                                            {formatFecha(
                                                dateCalculo.FechaPrimerVencimiento
                                            )}
                                        </label>

                                        <label className="o-layout__item u-1/2 labelConsT">
                                            Cuotas a pagar
                                        </label>
                                        <label className="o-layout__item u-1/2 labelConsT u-text-right u-pr">
                                            {new FunctionGeneral().formatNum(
                                                dateCalculo.CuotaMesActualNoVencida
                                            )}
                                        </label>

                                        <div
                                            className="u-1/1"
                                            style={{ height: '10px' }}
                                        >
                                            <hr />
                                        </div>

                                        <label className="o-layout__item u-1/2 labelConsT">
                                            Capital Pendiente
                                        </label>
                                        <label className="o-layout__item u-1/2 labelConsT u-text-right u-pr">
                                            {new FunctionGeneral().formatNum(
                                                dateCalculo.CapitalPendiente
                                            )}
                                            €
                                        </label>

                                        <label className="o-layout__item u-1/2 labelConsT">
                                            Importe días de interés
                                        </label>
                                        <label className="o-layout__item u-1/2 labelConsT u-text-right u-pr">
                                            {new FunctionGeneral().formatNum(
                                                dateCalculo.ImporteDiasIntereses
                                            )}
                                            €
                                        </label>

                                        <label className="o-layout__item u-1/2 labelConsT">
                                            Comisión de cancelación
                                        </label>
                                        <label className="o-layout__item u-1/2 labelConsT u-text-right u-pr">
                                            {new FunctionGeneral().formatNum(
                                                dateCalculo.ComisionCancelacion
                                            )}
                                            €
                                        </label>

                                        <label className="o-layout__item u-1/2 labelConsT">
                                            Importe Subvenciones
                                        </label>
                                        <label className="o-layout__item u-1/2 labelConsT u-text-right u-pr">
                                            <div
                                                style={{
                                                    margin: 'auto',
                                                    width: '24px',
                                                }}
                                                key={
                                                    dateCalculo.CodidoTransferencia +
                                                    '_'
                                                }
                                            >
                                                <div
                                                    className="js-tooltip c-tooltip"
                                                    data-template={
                                                        dateCalculo.CodidoTransferencia +
                                                        '_'
                                                    }
                                                >
                                                    <div
                                                        className="c-icon c-icon--[control-info-circle] u-float-left"
                                                        style={{
                                                            fontSize: '14px',
                                                        }}
                                                    ></div>
                                                </div>
                                                <div
                                                    id={
                                                        dateCalculo.CodidoTransferencia +
                                                        '_'
                                                    }
                                                    style={{ display: 'none' }}
                                                >
                                                    {item}
                                                </div>
                                            </div>
                                            {new FunctionGeneral().formatNum(
                                                dateCalculo.ImportePenzalizacion
                                            )}
                                            €
                                        </label>
                                        <label className="o-layout__item u-1/2 labelConsT">
                                            Devolución de comisión de apertura
                                            no devengada
                                        </label>
                                        <label className="o-layout__item u-1/2 labelConsT u-text-right u-pr">
                                            {new FunctionGeneral().formatNum(
                                                dateCalculo.AperturanoDevengada
                                            )}
                                            €
                                        </label>
                                        <div
                                            className="u-1/1"
                                            style={{ height: '10px' }}
                                        >
                                            <hr />
                                        </div>
                                        <label
                                            className="o-layout__item u-1/2 labelConsT"
                                            style={{ fontSize: '20px' }}
                                        >
                                            Total Importe a ingresar
                                        </label>
                                        <label
                                            className="o-layout__item u-1/2 labelConsT u-text-right u-pr"
                                            style={{ fontSize: '20px' }}
                                        >
                                            {new FunctionGeneral().formatNum(
                                                dateCalculo.TotalAIngresar
                                            )}
                                            €
                                        </label>
                                    </div>
                                </section>
                            )}
                        {dateCalculo.SolicitadaPorCliente && scrollTable && (
                            <div className="infoResumen">
                                <label
                                    className="o-layout__item u-1/2 labelConsT"
                                    style={{ fontSize: '20px' }}
                                >
                                    Nº transferencia
                                </label>
                                <label
                                    className="o-layout__item u-1/2 labelConsT u-text-right u-pr"
                                    style={{ fontSize: '20px' }}
                                >
                                    {dateCalculo.CodidoTransferencia}
                                </label>
                            </div>
                        )}
                        {dateCalculo.SolicitadaPorCliente && scrollTable && (
                            <div className="u-1/1 infoResumen">
                                <label className="o-layout__item u-1/1 labelConsT">
                                    Para proceder a la cancelación se deberá
                                    transferir el importe anterior en la fecha
                                    indicada a la cuenta bancaria:
                                </label>
                                <label className="o-layout__item u-1/3 labelConsT">
                                    Banco
                                </label>
                                <label className="o-layout__item u-2/3 labelConsT u-text-right u-pr">
                                    VOLKSWAGEN BANK GmbH Sucursal en España
                                </label>

                                <label className="o-layout__item u-1/3 labelConsT">
                                    IBAN
                                </label>
                                <label className="o-layout__item u-2/3 labelConsT u-text-right u-pr">
                                    ES08 1480 0010 9101 0000 0562
                                </label>
                                <label className="o-layout__item u-1/1 labelConsT">
                                    En el concepto de la transferencia deberá
                                    indicarse: LPAXXXXXXXX-0XX (Ej.:
                                    LPA00000001-001)
                                </label>
                            </div>
                        )}
                    </section>
                    <div className="u-1/1 u-mt">{printResultView()}</div>
                    <div
                        className="o-layout__item u-1/1"
                        style={{
                            marginTop:
                                resultSendCerticate.length === 0
                                    ? '65px'
                                    : '20px',
                        }}
                    >
                        <div className="u-1/2 u-float-left">
                            <button
                                className="c-btn--secondary c-btn u-p-small u-pl-large u-pr-large"
                                onClick={() =>
                                    props.setModalCancelacionAnticipada(false)
                                }
                            >
                                CERRAR
                            </button>
                        </div>
                        <div className="u-1/2 u-float-left">
                            {check_EnviarCertificado &&
                                resultSendCerticate.length === 0 &&
                                dateCalculo.SolicitadaPorCliente && (
                                    <button
                                        className="c-btn u-p-small"
                                        disabled={
                                            correoLPASend === '' ? true : false
                                        }
                                        onClick={() => {
                                            enviarCertificado();
                                        }}
                                    >
                                        Enviar certificado
                                    </button>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default withCookies(withRouter(ModalCancelacionAnticipada));
